import WorkflowIcon from "../../../assets/svg/workflow-icon";
import CrmDashboardIcon from "../../../assets/svg/crm-dashboard-icon";
import PropertyManagementIcon from "../../../assets/svg/property-management-icon";
import VerbachatIcon from "../../../assets/svg/verbachat-icon";
import VerbaCallIcon from "../../../assets/svg/verbacall-icon";
import VerbamessengerIcon from "../../../assets/svg/verbamessenger-icon";
import VerbamailIcon from "../../../assets/svg/verbamail-icon";
import WeChatV2Icon from "../../../assets/svg/v1/we-chat-v2-icon";
import WorkflowImage from "../../../assets/images/workflo-image-page.jpg";
import CrmDashboardImage from "../../../assets/images/crm-image-page.jpg";
import AnalyticsImage from "../../../assets/images/analytics-image-page.jpg";
import CommunicationImage from "../../../assets/images/communication-image-page.jpg";
import PmsImage from "../../../assets/images/pms-image-page.jpg";
import PlaygroundImage from "../../../assets/images/playground-image-page.jpg";
import AnalyticsIcon from "../../../assets/svg/analytics-icon";
import InboxIcon from "../../../assets/svg/inbox-icon";
import PlaygroundIcon from "../../../assets/svg/playground-icon";
import VerbasmsIcon from "../../../assets/svg/verbasms-icon";
import InstagramIcon from "../../../assets/svg/instagram-icon";
import FbMessengerIcon from "../../../assets/svg/fb-messenger-icon";
import { KamFeature, KamModality } from "../../../redux/services/kamApi";

type OrganizationClient = {
  client_code: string;
  client_name: string;
  client_logo: string | null;
};

type OrganizationItem = {
  clients?: OrganizationClient[];
};

export const getModalityIcon = (code: KamModality["code"]) => {
  switch (code) {
    case "whatsapp":
      return VerbamessengerIcon;
    case "email":
      return VerbamailIcon;
    case "wechat":
      return WeChatV2Icon;
    case "call":
    case "voice":
    case "phone":
      return VerbaCallIcon;
    case "sms":
      return VerbasmsIcon;
    case "widget":
      return VerbachatIcon;
    case "instagram":
      return InstagramIcon;
    case "fb_messenger":
      return FbMessengerIcon;
    default:
      return VerbaCallIcon;
  }
};

export const getModalityIconColor = (code: KamModality["code"]) => {
  switch (code) {
    case "whatsapp":
      return "w-5 h-5 text-verba-messenger dark:text-verba-messenger-dk";
    case "email":
      return "w-5 h-5 text-verba-mail dark:text-verba-mail-dk";
    case "wechat":
      return "w-5 h-5 text-verba-green-success dark:text-verba-green-success-dk";
    case "call":
    case "voice":
    case "phone":
      return "w-5 h-5 text-verba-lavender dark:text-verba-lavender-dk";
    case "sms":
      return "w-5 h-5 text-verba-sms dark:text-verba-sms-dk";
    case "widget":
      return "w-5 h-5 text-verba-chat dark:text-verba-chat-dk";
    case "instagram":
      return "w-5 h-5 text-verba-instagram dark:text-verba-instagram-dk";
    case "fb_messenger":
      return "w-5 h-5 text-verba-fb-messenger dark:text-verba-fb-messenger-dk";
    default:
      return "w-5 h-5 text-verba-lavender dark:text-verba-lavender-dk";
  }
};

export const formatModalityTag = (tag: KamModality["tag"]) => {
  if (!tag) {
    return undefined;
  }
  return `${tag.charAt(0).toUpperCase()}${tag.slice(1)}`;
};

export const getFeatureIcon = (code: KamFeature["code"]) => {
  switch (code) {
    case "crm":
      return CrmDashboardIcon;
    case "analytics":
      return AnalyticsIcon;
    case "communication":
      return InboxIcon;
    case "pms":
      return PropertyManagementIcon;
    case "workflo":
      return WorkflowIcon;
    case "playground":
      return PlaygroundIcon;
    default:
      return CrmDashboardIcon;
  }
};

export const getFeatureImage = (code: KamFeature["code"]) => {
  switch (code) {
    case "workflo":
      return WorkflowImage;
    case "playground":
      return PlaygroundImage;
    case "analytics":
      return AnalyticsImage;
    case "communication":
      return CommunicationImage;
    case "pms":
      return PmsImage;
    default:
      return CrmDashboardImage;
  }
};

export const formatFeatureTag = (tag: KamFeature["tag"]) => {
  if (!tag) {
    return undefined;
  }
  return `${tag.charAt(0).toUpperCase()}${tag.slice(1)}`;
};

export const extractOrganizationClients = (
  payload: OrganizationItem | OrganizationItem[] | undefined,
) => {
  if (!payload) {
    return [];
  }

  if (Array.isArray(payload)) {
    return payload.flatMap((organization) =>
      Array.isArray(organization?.clients) ? organization.clients : [],
    );
  }

  return Array.isArray(payload.clients) ? payload.clients : [];
};
